/* eslint-disable jsx-a11y/anchor-is-valid, camelcase */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import styled from 'react-emotion';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';

import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import urlFor from '~/modules/ecommerceCore/utils/UrlConcatination';
import ToggleButton from '~/modules/coreUI/components/basic/ToggleButton';
import { Row, Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import { OptionType } from '~/modules/ecommerceCoreUI/components/basic/Labels';
import externalRedirect from '~/modules/ecommerceCore/utils/externalRedirect';

import {
  getBestMatch,
  isOptionSelectable,
  isOptionRendered,
  isOptionTypeRendered,
} from '../rootVariantsUtils';

const OptionsButtonsContainer = styled(Row)`
  flex-wrap: wrap;

  & > * {
    margin-bottom: 15px;
  }
`;

const selectOption = (selectedOption, props) => {
  const { variants, initVariant: activeVariant } = props;
  const bestMatch = getBestMatch(selectedOption, activeVariant, variants);

  if (bestMatch.slug !== activeVariant.slug) {
    externalRedirect(
      urlFor('getProductDetailsLink', [
        bestMatch.slug,
        activeVariant.vendor ? 0 : bestMatch.vendor_variants_count,
        {
          ref_id: activeVariant.vendor?.ref_id,
          name: activeVariant.vendor?.name,
        },
      ]),
    );
  }
};

class Options extends React.PureComponent {
  render = () => (
    <Fragment>
      {_.concat(
        ..._.partition(this.props.optionTypes, optionType => optionType.presentation === 'Size'),
      ).map(optionType => (
        <Fragment key={optionType.ref_id}>
          {isOptionTypeRendered(optionType, this.props.variants) && (
            <Column key={optionType.ref_id} fullWidth leftAligned>
              <Row fullWidth spaceBetweenJustified={!this.props.media.minDesktop} topAligned>
                <OptionType media={this.props.media}>{optionType.presentation}</OptionType>
                {optionType.presentation === 'Size'
                && this.props.hasSizeChart && ( // TODO : A SOLID UNIQUE IDENTIFIER FROM BACKEND
                <Fragment>
                  <Spacer />
                  <Spacer />
                  <Label sm>
                    <a href="#" onClick={this.props.sizeChartToggle}>
                      {i18next.t('ecommerceCoreUI:Product.whatSize')}
                    </a>
                  </Label>
                </Fragment>
                )}
              </Row>
              <Spacer size={1.5} />
              <OptionsButtonsContainer>
                {optionType.option_values.map(
                  option => isOptionRendered(option, this.props.variants) && (
                  <div key={option.ref_id}>
                    <Row>
                      <ToggleButton
                        fullRound
                        disabled={!isOptionSelectable(option, this.props.initVariant, this.props.variants)}
                        clickable
                        ignoreClickEffect
                        selected={_.some(this.props.initVariant.option_values, { ref_id: option.ref_id })}
                        onClicked={() => {
                          selectOption(option, this.props);
                        }}
                        size="sm"
                      >
                        {option.presentation}
                      </ToggleButton>
                      <Spacer size={[1, 1, 1.5, 1.5]} />
                    </Row>
                  </div>
                  ),
                )}
              </OptionsButtonsContainer>
            </Column>
          )}
        </Fragment>
      ))}
    </Fragment>
  );
}

Options.propTypes = {
  variants: PropTypes.arrayOf(PropTypes.any).isRequired,
  // eslint-disable-next-line
  initVariant: PropTypes.shape().isRequired,
  optionTypes: PropTypes.arrayOf(PropTypes.any).isRequired,
  media: PropTypes.shape().isRequired,
  sizeChartToggle: PropTypes.func.isRequired,
  hasSizeChart: PropTypes.bool.isRequired,
};

export default withMedia(withRouter(Options));
